import React, { useState, useEffect } from 'react';
import { ShieldCheck, Truck, RotateCcw, Headphones, Star, Eye, Clock } from 'lucide-react';
import { formatDeliveryText } from '../../utils/delivery';

/**
 * Product page conversion boosters:
 * - Trust badges
 * - Live viewer count
 * - Low stock urgency
 * - Delivery estimate
 */

export function TrustBadges() {
  return (
    <div className="trust-badges" data-testid="trust-badges">
      <div className="trust-badge"><ShieldCheck size={16} /><span>Sichere Zahlung</span></div>
      <div className="trust-badge"><Truck size={16} /><span>Schneller Versand</span></div>
      <div className="trust-badge"><RotateCcw size={16} /><span>Widerrufsrecht</span></div>
      <div className="trust-badge"><Headphones size={16} /><span>Experten-Support</span></div>
    </div>
  );
}

export function LiveViewers() {
  const [viewers, setViewers] = useState(0);

  useEffect(() => {
    // Simulate realistic viewer count
    const base = Math.floor(Math.random() * 5) + 2;
    setViewers(base);
    const interval = setInterval(() => {
      setViewers(prev => Math.max(1, prev + Math.floor(Math.random() * 3) - 1));
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="live-viewers" data-testid="live-viewers">
      <Eye size={14} />
      <span><strong>{viewers} Personen</strong> sehen sich dieses Produkt gerade an</span>
    </div>
  );
}

export function StockUrgency({ stock }) {
  // Only show stock info when there's an actual inventory count > 0
  if (stock == null || stock <= 0) return null;
  if (stock <= 10) return (
    <div className="stock-urgency low" data-testid="stock-urgency">
      <Clock size={14} /> Nur noch <strong>{stock} Stück</strong> auf Lager!
    </div>
  );
  return null;
}

export function DeliveryEstimate({ deliveryTime, stock }) {
  if (!deliveryTime && stock == null) return null;
  const displayTime = formatDeliveryText(deliveryTime, stock);
  const isEstimate = /^ca\./i.test(displayTime);
  return (
    <div className="delivery-estimate" data-testid="delivery-estimate">
      <Truck size={14} />
      <span>Lieferzeit: <strong>{displayTime}</strong>{isEstimate ? ' (unverbindlich)' : ''}</span>
    </div>
  );
}

export function PaymentIcons() {
  return (
    <div className="payment-icons-product" data-testid="payment-icons">
      <span className="pi-label">Sicher bezahlen mit:</span>
      <div className="pi-icons">
        {['PayPal', 'Klarna', 'SEPA', 'Überweisung', 'Rechnung'].map(m => (
          <span key={m} className="pi-icon">{m}</span>
        ))}
      </div>
    </div>
  );
}
